import { render, staticRenderFns } from "./ComDiapositiva.vue?vue&type=template&id=0b152d39&scoped=true&"
import script from "./ComDiapositiva.vue?vue&type=script&lang=js&"
export * from "./ComDiapositiva.vue?vue&type=script&lang=js&"
import style0 from "./ComDiapositiva.vue?vue&type=style&index=0&id=0b152d39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b152d39",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VImg,VRow})
